export default __webpack_public_path__ + "easydl-wavesummitc5ef06.jpg";